var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.info !== null)?_c('OrderDescPopup',_vm._b({attrs:{"visible":_vm.visible},on:{"close":_vm.closePop,"click-outside":_vm.closePop}},'OrderDescPopup',_vm.info,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }